import {getVersionName} from '@aboutyou/config';
import {useCurrentPageTypeCallback, useHistory} from '@aboutyou/router';
import React, {useCallback, useEffect} from 'react';
import {getTransactionName} from '../DatadogLogsRouteTracker/getTransactionName';

export const DatadogRUMRouteTracker: React.FC = () => {
  const getCurrentPageType = useCurrentPageTypeCallback();
  const history = useHistory();

  const trackViewName = useCallback(
    (location: Location) => {
      const version = getVersionName();
      const currentPageType = getCurrentPageType();
      const url = `${location.pathname}${location.search}`;
      const transactionName = getTransactionName(url, currentPageType);

      try {
        window.DD_RUM?.onReady(() => {
          window.DD_RUM?.startView({
            name: transactionName,
            service: `aysa-frontend-${process.env.STACK}`,
            version,
          });
        });
      } catch (e) {}
    },
    [getCurrentPageType],
  );

  useEffect(() => {
    return history.listen(location => {
      trackViewName(location as unknown as Location);
    });
  }, [history, trackViewName]);

  return null;
};
